export default __webpack_public_path__ + "static/media/upcycled-000000.05212169.png";